import React, { PropsWithChildren, useContext } from 'react'
import SelectOptions from './SelectOptions'
import AppContext from '../appContext'

const SelectString = <TOptions, > (props: PropsWithChildren<SelectOptions<TOptions, string>>) => {
    const context = useContext(AppContext)
    return <select className="input" 
                   onChange={e => props.onChange(e.target.value)}
                   value={props.value ?? 0}
    >
        <option value={''} disabled>{context.word('choose_an_option')}</option>
        {props.options.map((l) => <option key={props.valueFunc(l)}
                                          value={props.valueFunc(l)}>{props.textFunc(l)}</option>)}
    </select>
}

export default SelectString;